export default "__VITE_ASSET__DXCNTeDI__"